<template>
  <div>
    <div class="flex justify-between">
      <h1 class="text-xl mb-8">Delivery Schedule - Local Deliveries</h1>
      <inertia-link :href="route('delivery.schedule', {type: 'vessel_location'})" class="border border-primary-400 rounded-sm p-3 m-2 text:primary-600 hover:bg-primary-100">Show Delivery To Vessels</inertia-link>
    </div>

    <div>
      <modal size="md" :show="assignTeam.show" @closeModal="resetAssignTeamState">
        <div>TEST TEST</div>
        <assign-modal v-if="assignTeam.order" :errors="modal_errors" :selected-team-id="assignTeam.team_id" :date="assignTeam.order.delivery_date" :order-id="assignTeam.order.id" @assign="orderAssignedToTeam" />
      </modal>

      <div>
        <select v-model="filter.group_by" class="w-full h-full bg-gray-300 py-2">
          <option :value="option.value" v-for="(option, optionKey) in groupByOptions" :key="optionKey">{{ option.label }}</option>
        </select>
      </div>

      <table class="w-full">
        <thead class="text-sm">
          <tr class="border bg-white">
            <th class="py-2 border w-1/12">Location</th>
            <th class="py-2 border w-1/12">Customer</th>
            <th class="py-2 border w-1/12">Order</th>
            <th class="py-2 border w-1/12">TQTY</th>
            <th class="py-2 border w-1/12">Status</th>
            <th class="py-2 border w-1/12">Team</th>
          </tr>
          <tr class="border bg-white">
            <th>
              <select v-model="filter.delivery_location" class="w-full h-full bg-gray-300 py-2">
                <option :value="null">All</option>
                <option v-for="lkey in Object.keys(locationList)" :key="lkey" :value="lkey">{{ locationList[lkey] }}</option>
              </select>
            </th>
            <th class="border w-1/12" />
            <th class="border w-1/12">
              <input v-model="filter.order_num" class="bg-gray-300 py-2 text-center w-full" placeholder="search order number">
            </th>
            <th class="border w-1/12" />
            <th class="border w-1/12">
              <select v-model="filter.delivery_status" class="w-full h-full bg-gray-300 py-2">
                <option :value="null" />
                <option value="not_started">Not Started</option>
                <option value="started">Started</option>
                <option value="paused">Paused</option>
                <option value="ended">Ended</option>
              </select>
            </th>
            <th class="border w-1/12">
              <select v-model="filter.status" class="w-full h-full bg-gray-300 py-2">
                <option :value="null">All</option>
                <option v-for="status in statusList" :key="status" :value="status">{{ status }}</option>
              </select>
            </th>
            <th class="border w-1/12">
              <select v-model="filter.delivery_team" class="w-full h-full bg-gray-300 py-2">
                <option :value="null">All</option>
                <option v-for="team in deliveryTeams" :key="team.id" :value="team.id">{{ team.name }}</option>
              </select>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(data, groupByFieldValue) in schedule">
            <tr v-if="groupBy == 'address'" class="border bg-gray-700 text-white">
              <td  colspan="7" class="px-4 py-2">{{ locationList[groupByFieldValue] }} </td>
            </tr>
            <tr v-else  :class="{'border' : true, 'bg-green-200 text-green-700': dateIsToday(groupByFieldValue), 'bg-red-100 text-red-800': dateIsPast(groupByFieldValue)}">
              <td colspan="3" class="px-4 py-2">{{ groupByFieldValue | localDateWithWeekDay }}</td>
              <td  colspan="1" class="px-4 py-2 text-center">{{  getTotalByDate(groupByFieldValue) }}</td>
              <td  colspan="3" class="px-4 py-2" />
            </tr>
            <template v-for="(rows, subGroupValue) in data">
              <tr class="border">
                <template v-if="groupBy === 'address'">

                <td colspan="3" :class="{'px-6 py-2' : true, 'bg-green-200 text-green-700': dateIsToday(subGroupValue), 'bg-red-100 text-red-800': dateIsPast(subGroupValue)}">
                  {{ subGroupValue | localDateWithWeekDay }}
                </td>
                <td :class="{'px-6 py-2 text-center' : true, 'bg-green-200 text-green-700': dateIsToday(subGroupValue), 'bg-red-100 text-red-800': dateIsPast(subGroupValue)}">
                  {{  getTotalByDate(subGroupValue, groupByFieldValue) }}
                </td>
                  <td colspan="3" :class="{'px-6 py-2' : true, 'bg-green-200 text-green-700': dateIsToday(subGroupValue), 'bg-red-100 text-red-800': dateIsPast(subGroupValue)}" />
                </template>
                <td v-else colspan="6" class='px-6 py-2 bg-gray-200 text-gray-700'> {{ subGroupValue }} </td>
              </tr>

              <tr v-for="(row, ridx) in rows" :key="row.id" class="border">
                <td class="pl-8 align-text-top py-1">{{ locationList[ridx] }}</td>
                <td class="pl-8 align-text-top py-1">{{ row.customer_account_name }}</td>
                <td class="text-center"><inertia-link :href="route('customer.orders.show',row.id)">{{ row.id }}</inertia-link></td>
                <td class="text-center"><inertia-link :href="route('customer.orders.show',row.id)">{{ row.items_total_qty }}</inertia-link></td>
                <td class="text-center py-1">
                  <select v-if="row.delivery_team" @input="(evt) => updateDeliveryStatus(evt.target.value, row)">
                    <option :disabled="row.delivery_status === null" :value="null" :selected="row.delivery_status === '' || row.delivery_status === null" ></option>
                    <option :disabled="row.delivery_status === 'started'" value="started" :selected="row.delivery_status === 'started' " >Started</option>
                    <option :disabled="row.delivery_status === 'paused'" value="paused" :selected="row.delivery_status === 'pasued' ">Paused</option>
                    <option :disabled="row.delivery_status === 'ended'" value="ended" :selected="row.delivery_status === 'ended' ">Ended</option>
                  </select>
                  <a v-if="!row.delivery_team && row.status === 'invoiced'" href="#" class="ml-3 rounded bg-blue-400 text-blue-900 text-xs px-1 py-1" @click="() => showAssignTeamModal(row)">Assign Team</a>
                  <a v-if="row.delivery_status === 'started'" :href="printOrderUrl(row.id)" target="_blank" class="ml-3 rounded bg-gray-300 text-xs px-1 py-1">Print</a>
                </td>
                <td class="text-center">{{ row.status }}</td>
                <td class="text-center">
                  <div v-if="row.delivery_team" class="flex justify-between pr-1">
                    <div>{{ row.delivery_team }}</div> <a v-if="!row.delivery_status" href="#" class="inline-flex items-center justify-center hover:text-white ml-3 h-6 w-6 rounded bg-purple-400 text-xs hover:bg-purple-800" @click="() => showReAssignTeamModal(row)">A</a>
                  </div>
                  <span v-else class="text-red-700">NOT ASSIGNED</span>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'
import debounce from 'lodash/debounce'
import pickBy from 'lodash/pickBy'
import moment from 'moment-timezone'
import AssignModal from '../MasterList/AssignModal'
import Modal from '@/Shared/Modal'
import {sumBy} from "lodash";

export default {
  name: 'Schedule',
  layout: Layout,
  components: {AssignModal, Modal},
  props: {
    groupBy: String,
    groupByOptions: Array,
    schedule: Object,
    deliveryTeams: Array,
    statusList: Array,
    locationList: Object,
    locationType: String,
  },
  data() {
    return {
      assignTeam: {
        team_id: null,
        show: false,
        order: null,
      },
      filter: {
        group_by: this.groupBy,
        delivery_date: null,
        delivery_location: null,
        order_num: null,
        status: null,
        delivery_team: null,
      },
      modal_errors: null,
    }
  },

  watch: {
    filter : {
      handler: debounce(function() {
        let query = pickBy(this.filter)
        query.type = this.locationType
        this.$inertia.get(this.route('delivery.schedule', Object.keys(query).length ? query : { remember: 'forget'}), {}, { preserveState: true })
      }, 300),
      deep: true,
    },
  },

  methods: {
    getTotalByDate(date, location) {
      let dateTotal = 0;

      if (location && this.schedule[location] && this.schedule[location][date]) {
        const deliveries = Object.values(this.schedule[location][date]).flat();

        dateTotal = sumBy(deliveries, delivery => Number(delivery.items_total_qty))
      } else {
        const deliveries = Object.values(this.schedule[date]).flat()
        dateTotal = sumBy(deliveries, delivery => Number(delivery.items_total_qty))
      }

      return dateTotal;
    },

    getRowCount(rows) {
      return rows.length
    },
    dateIsToday(deliveryDate)
    {
      let currentDate = moment()
      return currentDate.isSame(deliveryDate, 'day')
    },
    dateIsPast(deliveryDate)
    {
      let currentDate = moment()
      return currentDate.isAfter(deliveryDate, 'day')
    },
    printOrderUrl(orderId) {
      return '/delivery-list/print/' + orderId
    },

    updateDeliveryStatus(delivery_status, order) {
      let originalStatus = order.delivery_status
      this.$http.post(this.route('ajax.customer.orders.update-delivery-status', {customerOrder: order.id}), {delivery_status})
        .then(() => {
          order.delivery_status = delivery_status
        }).catch(() => {
        order.delivery_status = originalStatus
      })
    },


    showAssignTeamModal(order) {
      this.assignTeam.order = order
      this.assignTeam.show = true
    },

    showReAssignTeamModal(order) {
      this.assignTeam.team_id = order.delivery_team_id
      this.assignTeam.order = order
      this.assignTeam.show = true
    },

    orderAssignedToTeam(team) {
      let teamId = team.team_id
      let deliveryDate = team.delivery_date
      let order = this.assignTeam.order
      // ajax call and update the order items as assigned to the team
      this.$http.post(this.route('ajax.customer.orders.assign-delivery-team', {customerOrder: order.id}), {
        team_id: teamId,
        delivery_date: deliveryDate,
      }).then(() => {
        this.modal_errors = null
        order.delivery_team = team.name
        if(team.delivery_date !== order.deliver_date) {
          order.deliver_date = team.delivery_date
          this.$inertia.reload({ only: ['schedule'] })
        }
        // reset assignTeam state
        this.resetAssignTeamState()
      }).catch(error => {
        if(error.response.status === 403) {
          this.modal_errors = {
            message: error.response.data.message
          }
        } else {
          if(error.response.status === 403) {
            this.modal_errors = {
              message: error.response.data.message
            }
          } else {
            this.modal_errors = error.response.data.errors
            this.modal_errors.message = error.response.data.message
          }
        }
      })
    },

    resetAssignTeamState() {
      this.assignTeam.order = null
      this.assignTeam.show = false
      this.assignTeam.team_id = null
      this.modal_errors = null
    },
  },
}
</script>
